import { SyntheticEvent } from 'react';

/**
 * Custom hook to manage image loading and error states.
 * @returns an object containing image handling actions
 */
export const useFallbackImageManager = () => {
  /**
   * Handles image loading errors by replacing the source with a placeholder image.
   * Ensures that the fallback is applied only once to prevent infinite loading loops.
   *
   * @param e - SyntheticEvent triggered on image error
   * @param placeHolderImageSrc - The placeholder image source to use
   */
  const applyFallbackImage = (
    e: SyntheticEvent<HTMLImageElement, Event>,
    placeHolderImageSrc: string,
  ) => {
    const placeholderUrl: string = new URL(placeHolderImageSrc, window.location.href).href;
    if (e.currentTarget.src && e.currentTarget.src !== placeholderUrl) {
      e.currentTarget.src = placeHolderImageSrc;
    }
  };

  return {
    applyFallbackImage,
  };
};
